import { Controller } from "@hotwired/stimulus"

// Opens/closes a native <dialog>. Replaces inline onclick handlers, which the
// app's CSP blocks (nonces don't apply to inline event handlers).
//
//   <div data-controller="dialog">
//     <button data-action="dialog#open">Open</button>
//     <dialog data-dialog-target="modal">
//       <button data-action="dialog#close">Cancel</button>
//     </dialog>
//   </div>
export default class extends Controller {
  static targets = ["modal"]

  open(event) {
    if (event) event.preventDefault()
    this.modalTarget.showModal()
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.close()
  }

  // Native <dialog> treats a click on the backdrop as a click on the element
  // itself, so compare against the bounding box to detect outside clicks.
  closeOnBackdrop(event) {
    if (event.target !== this.modalTarget) return

    const box = this.modalTarget.getBoundingClientRect()
    const inside =
      event.clientX >= box.left &&
      event.clientX <= box.right &&
      event.clientY >= box.top &&
      event.clientY <= box.bottom

    if (!inside) this.modalTarget.close()
  }
}
